import {combineReducers} from '@reduxjs/toolkit';
import {auth} from 'feedback-system/auth/reducers';
import {qualityFeedback} from '../modules/quality-feedback/services/reducers';
import {settings} from '../modules/settings/services/reducers';
import {feedbackOverview} from '../modules/feedback-overview/services/reducers';
import {consolidatedFeedback} from '../modules/feedback-consolidation/services/reducers';
import {profiles} from '../controllers/profile/services/reducers';
import {periods} from '../controllers/periods/services/reducers';
import emloyeesReducer from '../modules/employees/services/reducers';
import {synchronizer} from '../controllers/synchronizer/services/reducers';
import authReducer from '../modules/login/services/reducers';
import {notifications} from '../modules/notifier/services/reducers';
import {lastView} from '../controllers/last-view/services/reducers';
import {projects} from '../controllers/projects/services/reducers';
import {statistic} from '../controllers/statistic/services/reducers';

const rootReducer = combineReducers({
    auth,
    qualityFeedback,
    consolidatedFeedback,
    feedbackOverview,
    settings,
    profiles,
    periods,
    emloyeesReducer,
    authReducer,
    synchronizer,
    notifications,
    lastView,
    projects,
    statistic
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>;
